import { cn } from "../../helpers";
import { paragraph } from "../typography";

const root = cn("bg-blurple-800 p-3");
const rootClose = cn("flex justify-between items-center gap-1");
const textContainer = cn("flex flex-col w-full justify-center");
const title = cn(
  paragraph({ size: "md", className: "text-white text-center" }),
);
const subtitle = cn(
  paragraph({ size: "sm", className: "text-white text-center" }),
);
const closeButton = cn(
  "cursor-pointer w-8 h-8 bg-white bg-opacity-25 flex justify-center items-center shrink-0 rounded-full hover:bg-opacity-30 transition-all",
);

export { closeButton, root, rootClose, subtitle, textContainer, title };
